import { DropdownMenu as MenuPrimitive } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/shared/lib';

/**
 * Меню (README §1: меню роли/профиля над подвалом сайдбара): фон paper-pure, radius 10,
 * тень меню (кольцо gold-soft + 0 8 24), появление lwRise 160 ms; надзаголовок 10/500 uppercase
 * gold-leaf-3; пункты padding 10 14, разделитель line-soft, hover surface-sunken.
 */
export const DropdownMenu = MenuPrimitive.Root;
export const DropdownMenuTrigger = MenuPrimitive.Trigger;

export function DropdownMenuContent({
  className,
  sideOffset = 8,
  ...props
}: ComponentProps<typeof MenuPrimitive.Content>) {
  return (
    <MenuPrimitive.Portal>
      <MenuPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          'z-50 min-w-216 overflow-hidden rounded-10 bg-paper-pure shadow-menu animate-rise-menu focus-visible:outline-none',
          className,
        )}
        {...props}
      />
    </MenuPrimitive.Portal>
  );
}

export function DropdownMenuLabel({ children }: { children: ReactNode }) {
  return (
    <MenuPrimitive.Label className="px-14 pt-12 pb-8 text-[10px] font-medium tracking-[0.1em] text-gold-leaf-3 uppercase">
      {children}
    </MenuPrimitive.Label>
  );
}

const itemClasses =
  'flex cursor-pointer items-center gap-10 border-t border-line-soft px-14 py-10 text-[13px] font-medium text-ink-700 outline-none select-none data-highlighted:bg-surface-sunken data-highlighted:text-ink-900 data-disabled:cursor-not-allowed data-disabled:text-ink-400';

export function DropdownMenuItem({
  className,
  ...props
}: ComponentProps<typeof MenuPrimitive.Item>) {
  return <MenuPrimitive.Item className={cn(itemClasses, className)} {...props} />;
}

export const DropdownMenuRadioGroup = MenuPrimitive.RadioGroup;

/** Пункт-переключатель с точкой 6 (как пункты меню роли прототипа: активная — wine-bordeaux). */
export function DropdownMenuRadioItem({
  className,
  children,
  ...props
}: ComponentProps<typeof MenuPrimitive.RadioItem>) {
  return (
    <MenuPrimitive.RadioItem className={cn(itemClasses, 'group', className)} {...props}>
      <span
        aria-hidden="true"
        className="size-6 shrink-0 rounded-pill bg-line-strong group-data-[state=checked]:bg-wine-bordeaux"
      />
      <span className="group-data-[state=checked]:text-ink-900">{children}</span>
    </MenuPrimitive.RadioItem>
  );
}
